import { watch } from 'vue';
import { brandMessages } from 'shared/helpers/brandText';
import en from './locale/en';

// English ships with the entry bundle. Every other locale is a separate chunk
// fetched the first time it is selected, so the initial download does not
// carry ~40 copies of the dashboard strings. Keep in sync with ./index.js.
const localeLoaders = {
  ar: () => import('./locale/ar'),
  bg: () => import('./locale/bg'),
  ca: () => import('./locale/ca'),
  cs: () => import('./locale/cs'),
  da: () => import('./locale/da'),
  de: () => import('./locale/de'),
  el: () => import('./locale/el'),
  es: () => import('./locale/es'),
  et: () => import('./locale/et'),
  fa: () => import('./locale/fa'),
  fi: () => import('./locale/fi'),
  fr: () => import('./locale/fr'),
  he: () => import('./locale/he'),
  hi: () => import('./locale/hi'),
  hu: () => import('./locale/hu'),
  id: () => import('./locale/id'),
  it: () => import('./locale/it'),
  ja: () => import('./locale/ja'),
  ko: () => import('./locale/ko'),
  ml: () => import('./locale/ml'),
  lv: () => import('./locale/lv'),
  nl: () => import('./locale/nl'),
  no: () => import('./locale/no'),
  pl: () => import('./locale/pl'),
  pt_BR: () => import('./locale/pt_BR'),
  pt: () => import('./locale/pt'),
  ro: () => import('./locale/ro'),
  ru: () => import('./locale/ru'),
  sk: () => import('./locale/sk'),
  sl: () => import('./locale/sl'),
  sr: () => import('./locale/sr'),
  sv: () => import('./locale/sv'),
  ta: () => import('./locale/ta'),
  th: () => import('./locale/th'),
  tr: () => import('./locale/tr'),
  uk: () => import('./locale/uk'),
  uz: () => import('./locale/uz'),
  vi: () => import('./locale/vi'),
  zh_CN: () => import('./locale/zh_CN'),
  zh_TW: () => import('./locale/zh_TW'),
  is: () => import('./locale/is'),
  lt: () => import('./locale/lt'),
};

export const defaultMessages = brandMessages({ en });

export const loadLocaleMessages = async (i18n, locale) => {
  const loadLocale = localeLoaders[locale];
  if (!loadLocale || i18n.global.availableLocales.includes(locale)) return;

  const { default: messages } = await loadLocale();
  i18n.global.setLocaleMessage(locale, brandMessages(messages));
};

// Fetches the messages whenever the app switches locale. Until they arrive,
// vue-i18n falls back to English.
export const watchLocaleMessages = i18n =>
  watch(i18n.global.locale, locale => loadLocaleMessages(i18n, locale));
